import {useQuery} from "@tanstack/react-query";
import {usersUserIdContactsGet} from "../api/users/contacts/usersUserIdContactsGet.ts";

export const useUserContacts = (userId: number, enabled: boolean) =>
    useQuery({
        queryKey: ['userContacts', userId],
        queryFn: () => usersUserIdContactsGet(userId).then(r => r.payload),
        enabled
    })